// Admin listing constants ==============================================
export const ADMIN_LISTINGS_REQUEST = "ADMIN_LISTINGS_REQUEST";
export const ADMIN_LISTINGS_SUCCESS = "ADMIN_LISTINGS_SUCCESS";
export const ADMIN_LISTINGS_FAIL = "ADMIN_LISTINGS_FAIL";

export const ADMIN_LISTING_DETAILS_REQUEST = "ADMIN_LISTING_DETAILS_REQUEST";
export const ADMIN_LISTING_DETAILS_SUCCESS = "ADMIN_LISTING_DETAILS_SUCCESS";
export const ADMIN_LISTING_DETAILS_FAIL = "ADMIN_LISTING_DETAILS_FAIL";

export const ADMIN_UPDATE_LISTING_REQUEST = "ADMIN_UPDATE_LISTING_REQUEST";
export const ADMIN_UPDATE_LISTING_SUCCESS = "ADMIN_UPDATE_LISTING_SUCCESS";
export const ADMIN_UPDATE_LISTING_RESET = "ADMIN_UPDATE_LISTING_RESET";
export const ADMIN_UPDATE_LISTING_FAIL = "ADMIN_UPDATE_LISTING_FAIL";

export const ADMIN_DELETE_LISTING_REQUEST = "ADMIN_DELETE_LISTING_REQUEST";
export const ADMIN_DELETE_LISTING_SUCCESS = "ADMIN_DELETE_LISTING_SUCCESS";
export const ADMIN_DELETE_LISTING_RESET = "ADMIN_DELETE_LISTING_RESET";
export const ADMIN_DELETE_LISTING_FAIL = "ADMIN_DELETE_LISTING_FAIL";

// User listing constants ==============================================
// Create
export const SAVE_PROPERTY_ADDRESS = "SAVE_PROPERTY_ADDRESS";
export const SAVE_PROPERTY_DETAILS = "SAVE_PROPERTY_DETAILS";

export const NEW_LISTING_REQUEST = "NEW_LISTING_REQUEST";
export const NEW_LISTING_SUCCESS = "NEW_LISTING_SUCCESS";
export const NEW_LISTING_RESET = "NEW_LISTING_RESET";
export const NEW_LISTING_FAIL = "NEW_LISTING_FAIL";
export const NEW_LISTING_CLEAR_ERRORS = "NEW_LISTING_CLEAR_ERRORS";

// List
export const USER_LISTINGS_REQUEST = "USER_LISTINGS_REQUEST";
export const USER_LISTINGS_SUCCESS = "USER_LISTINGS_SUCCESS";
export const USER_LISTINGS_FAIL = "USER_LISTINGS_FAIL";

// Read
export const USER_LISTING_DETAILS_REQUEST = "USER_LISTING_DETAILS_REQUEST";
export const USER_LISTING_DETAILS_SUCCESS = "USER_LISTING_DETAILS_SUCCESS";
export const USER_LISTING_DETAILS_CLEANUP_STATE = "USER_LISTING_DETAILS_CLEANUP_STATE";
export const USER_LISTING_DETAILS_FAIL = "USER_LISTING_DETAILS_FAIL";
export const CLEAR_ERRORS_LISTING_DETAILS = "CLEAR_ERRORS_LISTING_DETAILS";

// Update
export const UPDATE_SAVE_PROPERTY_ADDRESS = "UPDATE_SAVE_PROPERTY_ADDRESS";
export const UPDATE_SAVE_PROPERTY_DETAILS = "UPDATE_SAVE_PROPERTY_DETAILS";

export const UPDATE_LISTING_REQUEST = "UPDATE_LISTING_REQUEST";
export const UPDATE_LISTING_SUCCESS = "UPDATE_LISTING_SUCCESS";
export const UPDATE_LISTING_RESET = "UPDATE_LISTING_RESET";
export const UPDATE_LISTING_FAIL = "UPDATE_LISTING_FAIL";
export const UPDATE_LISTING_CLEAR_ERRORS = "UPDATE_LISTING_CLEAR_ERRORS";

// Delete
export const DELETE_LISTING_USER_REQUEST = "DELETE_LISTING_USER_REQUEST";
export const DELETE_LISTING_USER_SUCCESS = "DELETE_LISTING_USER_SUCCESS";
export const DELETE_LISTING_USER_FAIL = "DELETE_LISTING_USER_FAIL";
export const DELETE_LISTING_USER_SUCCESS_RESET =
  "DELETE_LISTING_USER_SUCCESS_RESET";
export const DELETE_LISTING_USER_ERROR_RESET =
  "DELETE_LISTING_USER_ERROR_RESET";

export const ALL_LISTINGS_REQUEST = "ALL_LISTINGS_REQUEST";
export const ALL_LISTINGS_SUCCESS = "ALL_LISTINGS_SUCCESS";
export const ALL_LISTINGS_FAIL = "ALL_LISTINGS_FAIL";

// Like listing
export const USER_UNLIKE_LISTING_SUCCESS = "USER_UNLIKE_LISTING_SUCCESS";
export const USER_LIKE_LISTING_SUCCESS = "USER_LIKE_LISTING_SUCCESS";
export const USER_LIKE_LISTING_FAIL = "USER_LIKE_LISTING_FAIL";

// Like listing
export const USER_UNLIKE_LISTING_SUCCESS_FROM_LIKES = "USER_UNLIKE_LISTING_SUCCESS_FROM_LIKES";
export const USER_GET_LIKED_LISTINGS_REQUEST = "USER_GET_LIKED_LISTINGS_REQUEST";
export const USER_GET_LIKED_LISTINGS_SUCCESS = "USER_GET_LIKED_LISTINGS_SUCCESS";
export const USER_GET_LIKED_LISTINGS_FAIL = "USER_GET_LIKED_LISTINGS_FAIL";

// Public listing constants ==============================================

export const GET_LISTINGS_PUBLIC_REQUEST = "GET_LISTINGS_PUBLIC_REQUEST";
export const GET_LISTINGS_PUBLIC_SUCCESS = "GET_LISTINGS_PUBLIC_SUCCESS";
export const GET_LISTINGS_PUBLIC_FAIL = "GET_LISTINGS_FAIL";
export const GET_LISTINGS_PUBLIC_CLEAR_ERRORS = "GET_LISTINGS_CLEAR_ERRORS";

export const INCREASE_VIEW_COUNT_CARD = "INCREASE_VIEW_COUNT_CARD";
export const INCREASE_VIEW_COUNT_MAP = "INCREASE_VIEW_COUNT_MAP";
//

export const CLEAR_ERRORS = "CLEAR_ERRORS";
